module.exports = __webpack_public_path__ + "static/media/nt.8cc72442.png";